import { render, staticRenderFns } from "./order-info.vue?vue&type=template&id=3ebc3de1"
import script from "./order-info.vue?vue&type=script&lang=js"
export * from "./order-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports